import Component from 'components/pages/Rewards/PayPalRewards/PayPalRewards';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('rewards');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Paypal Rewards',
    description: 'Paypal rewards',
  },
});
